import { render, staticRenderFns } from "./uploadPeople.vue?vue&type=template&id=52e49ed0&scoped=true"
import script from "./uploadPeople.vue?vue&type=script&lang=js"
export * from "./uploadPeople.vue?vue&type=script&lang=js"
import style0 from "./uploadPeople.vue?vue&type=style&index=0&id=52e49ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e49ed0",
  null
  
)

export default component.exports